export enum LengthType
{
    /// <summary>The value is expressed as a mm. </summary>
    LengthValue,
    Auto,
    /// <summary>The value is expressed as a weighted proportion of available space. </summary>
    Star,
    Range
}